<template>
<!--
  Local URL: http://localhost:8080/curate-vectraits 
  Required Group Membership: Curator or Admin
  Purpose: This page is for members of the Curators group. It features a table displaying previously uploaded 
  VecTraits files and their status. Clicking on a row in the table will take you to the detail page for that uploaded 
  file where you can see more information about the file, download the file and accept/reject the file.
-->
  <VTBaseTemplate>
    <b-modal
      id="api-err-modal"
      v-model="apiErrModalShow"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Error"
      :header-bg-variant="'warning'"
      :header-text-variant="'light'">
      <span v-html="err_msg"></span>
      <b-button class="mt-3" block @click="hideModal">OK</b-button>
    </b-modal>
    <br><br><br>
    <div class="w-100 h-100">
      <div class="title-area">
          <center>
            <br><br><br>
            <img
              src="@/assets/images/logos/vectrait_logo.svg"
              class="mr-2"
              width=45px
            />
            <h2>Curate VecTraits File Uploads</h2>
          </center>
        </div>
      <b-container fluid>
          <b-button v-b-toggle.collapse-instructions variant="primary">Instructions</b-button>
          <b-collapse id="collapse-instructions">
            <div style="padding:15px;">
              <p><b>Curating Files</b></p>
              <p>The table below lists all of the VecTraits files that have been uploaded by users with upload 
                priveledges. Click on a row to review the file.</p>
              <p><b>File Status</b></p>
              <ul>
                <li>Uploaded: This file was uploaded but was not confirmed or rejected by the uploader.</li>
                <li>Confirmed: This file was uploaded and the uploader has reviewed it and confirmed that the file 
                  is ready for a curator to review it.</li>
                <li>Rejected: This file either has errors or was manually rejected by a curator.</li>
                <li>Commited: This file has been reviewed and accepted by a curator. The data has been commited to 
                  the database.</li>
              </ul>
            </div>
          </b-collapse>
        </b-container>
        <hr />

      <!-- FILE TABLE SECTION -->
      <b-container fluid>
        <div style="padding: 50px;">
          <h3>Uploaded VecTraits Files:</h3>
            <b-table
              ref="table"
              striped 
              hover 
              responsive
              selectable
              select-mode='single'
              bordered
              head-variant="light"
              style="overflow-x:auto"
              
              @row-selected="onRowSelected"
              :items="myProvider"
              :fields="fields"
              :busy.sync="loading"
              :current-page="options.currentPage"
              :per-page="options.perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"

              tbody-tr-class="vt-table-row"
            >
              <!-- https://bootstrap-vue.org/docs/components/table#table-busy-state -->
              <template #table-busy>
                  <div class="text-danger my-2">
                      <b-spinner class="align-left"></b-spinner>
                      <strong>&nbsp;Loading...</strong>
                  </div>
              </template>
              <template v-slot:cell()="data"><!--Tooltip-->
                <span  :title='data.value'>{{ data.value}}</span>
              </template>
            </b-table>

            <b-pagination
                v-if="options.totalRows"
                v-model="options.currentPage"
                :total-rows="options.totalRows"
                :per-page="options.perPage"
                align="right"
                size="sm"
                class="my-0"
            ></b-pagination>

            <b-modal id="modal-1" size="lg" scrollable title="Details">
              <b-table
                  responsive
                  stacked
                  :items="modal_items"
                  :fields="modal_fields"
              ></b-table>
            </b-modal>
        </div>
      </b-container>
    </div>
  </VTBaseTemplate>
</template>

<script>
// @ is an alias to /src
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import VTBaseTemplate from "@/layouts/VTBaseTemplate.vue";
export default {
    name: "curate-vectraits",
    mixins: [VTBaseTemplate],
    components: {
        VTBaseTemplate
    },
    data(){
        return{
            data: [],
            summary: false,
            file_upload_objs: [],
            summary_list: [],
            error_list: [],
            err_msg: '',
            apiErrModalShow: false,
            loading: false,
            show_files: true,
            sortBy: "id",
            sortDesc: false,
            modal_items: [],
            modal_fields: [],
            options: {
                currentPage: 1,
                totalRows: 0,
                perPage: 50
            },
            fields: [
              { key: 'id', sortable: true, tdClass: 'text-truncate vt-table-cell' },
              { key: 'file_name', sortable: true, tdClass: 'text-truncate vt-table-cell' },
              // { key: 'file', sortable: true, tdClass: 'text-truncate vt-table-cell' },
              { key: 'uploader', sortable: true, tdClass: 'text-truncate vt-table-cell' },
              { key: 'status', sortable: true, tdClass: 'text-truncate vt-table-cell' },
              { key: 'created', sortable: true, tdClass: 'text-truncate vt-table-cell' },
              { key: 'modified', sortable: true, tdClass: 'text-truncate vt-table-cell' },
            ],
        };
    },
    computed: {},
    watch: {
      view: function() {
          this.$refs.table.refresh();
      }
    },
    created() {
      document.title = "Curate VecTraits File Uploads";
    },
    methods: {
      hideModal() {
        this.apiErrModalShow = false;
      },
      myProvider(ctx) {
            this.$bvModal.hide('modal-1');
            const that = this;

            // build the params object to be sent with the request.
            var params = new URLSearchParams();
            params.append("page", ctx.currentPage)
            params.append("sort_column", that.sortBy)
            params.append("sort_dir", that.sortDesc ? "desc" : "asc")

            var request = {
                params: params
            };

            return HTTP.get(`/api/vectraits-uploads/`, request)
            .then(response => {
                that.data = response.data.results;
                that.options.totalRows = parseInt(response.data.count);
                return that.data;
            })
            .catch(error => {
                this.err_msg = HandleErrors.HandleErrors(error);
                this.apiErrModalShow = true;
                return [];
            });
        },
        onRowSelected(items) {
            this.$router.push({ path: '/vt-fileupload-detail/' +  items[0]['id']});
        },
        beforeRouteLeave(to, from, next) {
            this.$bvModal.hide('modal-1');
            next();
        },
        toggleFilesTable: function() {
          this.show_files = !this.show_files;
        },
    },
};
</script>

<style scoped>
  .table-head {
    background: #777;
    font-weight: bold;
    text-align: left;
    padding: 5px;
  }
</style>